import React, { useRef, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import TaxInvoicePrintLayout from './TaxInvoicePrintLayout';

const TaxInvoicePreviewDialog = ({ visible, onHide, invoice, defaultSeller }) => {
    const sheetRef = useRef(null);
    const [downloading, setDownloading] = useState(false);

    const handlePrint = () => {
        window.print();
    };

    const handleDownloadPdf = async () => {
        if (!sheetRef.current) return;
        setDownloading(true);
        try {
            const [{ default: html2canvas }, { default: jsPDF }] = await Promise.all([import('html2canvas'), import('jspdf')]);
            const canvas = await html2canvas(sheetRef.current, { scale: 2, useCORS: true, backgroundColor: '#ffffff' });
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const imgHeight = (canvas.height * pageWidth) / canvas.width;

            if (imgHeight <= pageHeight) {
                pdf.addImage(imgData, 'PNG', 0, 0, pageWidth, imgHeight);
            } else {
                // Slice the tall canvas across multiple A4 pages.
                let heightLeft = imgHeight;
                let position = 0;
                pdf.addImage(imgData, 'PNG', 0, position, pageWidth, imgHeight);
                heightLeft -= pageHeight;
                while (heightLeft > 0) {
                    position -= pageHeight;
                    pdf.addPage();
                    pdf.addImage(imgData, 'PNG', 0, position, pageWidth, imgHeight);
                    heightLeft -= pageHeight;
                }
            }
            pdf.save(`${invoice?.invoice_no || 'Tax_Invoice'}.pdf`);
        } finally {
            setDownloading(false);
        }
    };

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            header={`Invoice ${invoice?.invoice_no || ''}`}
            style={{ width: '900px', maxWidth: '95vw' }}
            className="tax-invoice-preview-dialog"
            footer={
                <div className="flex justify-content-end gap-2">
                    <Button label="Close" className="p-button-text" onClick={onHide} />
                    <Button label="Print" icon="pi pi-print" className="p-button-secondary" onClick={handlePrint} />
                    <Button label="Download PDF" icon="pi pi-download" loading={downloading} onClick={handleDownloadPdf} />
                </div>
            }
        >
            <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <TaxInvoicePrintLayout ref={sheetRef} invoice={invoice} defaultSeller={defaultSeller} />
            </div>
        </Dialog>
    );
};

export default TaxInvoicePreviewDialog;
